import { render, staticRenderFns } from "./imaged-objects.vue?vue&type=template&id=1b84298e&scoped=true&"
import script from "./imaged-objects.vue?vue&type=script&lang=ts&"
export * from "./imaged-objects.vue?vue&type=script&lang=ts&"
import style0 from "./imaged-objects.vue?vue&type=style&index=0&id=1b84298e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b84298e",
  null
  
)

export default component.exports